import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Operation } from "../state/types"

export const useOperationActions = () => {
    const saveActions = useSaveActions()

    const saveOperation = (
        table: TableName,
        operation: Operation
    ) => {
        const { save } = saveActions()
        return save(table, operation) as Promise<Operation>
    }

    return {
        saveOperation
    }
}
